import analyticsActions from './analyticsActions';

export default { ...analyticsActions };
